import { environment } from '@environment';

export function isEngineWheel(): boolean {
  return (
    !!environment.engineApiUrl &&
    /^\/engine(?:\/|$)/.test(window.location.pathname)
  );
}
